












import {Component, Vue} from 'vue-property-decorator';

import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";
import {CreateTraineeRequestModel} from "@/domain/trainees/CreateTraineeRequestModel";

import {getAuthenticationClient} from '@/authentication/getAuthenticationClient';

@Component({})

export default class progressMap extends Vue {

    public grass: HTMLImageElement | null = null;

    async mounted() {
        this.grass = new Image();
        this.grass.src = '/map/grass.png';
        const self:progressMap = this;
        this.grass.onload = function () {

            const canvas = document.getElementById("can") as HTMLCanvasElement;

            const ctx = canvas.getContext("2d");
            if (ctx != null && self.grass != null) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                ctx.drawImage(self.grass, 0, 0);


            }
        }
    }
}
